import { PostAbout } from "./types";

import * as S from "./styles";

const Author = (props: PostAbout) => {
  return (
    <S.Author>
      <S.Thumbnail size="xl" name={props.name}>
        <img
          src={`${props.thumbnail}`}
          alt={props.name}
        />
      </S.Thumbnail>
      <S.Right>
        <S.Name>{props.name}</S.Name>
        <S.Description>{props.description}</S.Description>
      </S.Right>
    </S.Author>
  );
};

export default Author;
